import type { Popup } from 'popups/Popup';
import type { PopupStackController } from '../popups/PopupStackController';
import type { MetaPopupController } from './types';

export class MetaPopupStackController implements MetaPopupController {
  constructor(private readonly popups: PopupStackController) {}

  public addPopup(instance: Popup): Promise<void> {
    return this.popups.addPopup({
      popupInstance: instance,
      settings: { hideRays: true, overlay: false, overlayFillOpacity: 0 },
    });
  }

  public closeActivePopup(): Promise<void> {
    return this.popups.closeActivePopup();
  }
}
